export const AUTH_CONFIG = {
    id_token: "",
    access_token: "",
    refresh_token: ""
}